import { defineMessages } from 'react-intl';

const messages = defineMessages({

  add: {
    id: 'AddListSettingsForm.add',
    defaultMessage: 'Add',
    description: 'Add Button',
  },
  update: {
    id: 'ListSettingsForm.update',
    defaultMessage: 'Update',
    description: 'Update Button',
  },
  delete: {
    id: 'ListSettingsForm.delete',
    defaultMessage: 'Delete',
    description: 'Delete Button',
  },
  addNew: {
    id: 'ListSettingsForm.addNew',
    defaultMessage: 'Name',
    description: 'Name',
  },
  addNewDescription: {
    id: 'ListSettingsForm.addNewDescription',
    defaultMessage: 'Description',
    description: 'description',
  },
  required: {
    id: 'ListSettingsForm.required',
    defaultMessage: '*Required',
    description: 'Required',
  },
  exceedLimit: {
    id: 'exceedLimit',
    defaultMessage: 'Maximum allowed character is 255.',
    description: 'exceedLimit',
  },
  descLimitError: {
    id: 'app.descLimitError',
    defaultMessage: 'Limit exceeded! You can enter up to 10,000 characters',
    description: 'Limit exceeded! You can enter up to 10,000 characters'
  },
  limitExceed: {
    id: 'app.limitExceed',
    defaultMessage: 'Exceeding character limit',
    description: 'Exceeding character limit'
  },
  textAreaError: {
    id: 'app.textAreaError',
    defaultMessage: ' Limit exceeded! you can add up to 250 characters',
    description: 'Limit exceeded! you can add up to 250 characters'
  },
});

export default messages;
